import colors from './colors'

export const onfsLinkStyle = {
  color: colors.primaryDark,
  fontWeight: 800,
  textDecoration: 'none',
  display: 'inline-block',
  background: 'none',
  border: 'none',
  padding: '0px'
}

export const onfsLinkStyleHovered = {
  ...onfsLinkStyle,
  textDecoration: 'underline',
  color: colors.dark
}
